import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='M23 11.08a1 1 0 1 0-2 0zM22 12h1zm-6.337-8.227a1 1 0 0 0 .814-1.826zm7.044.934a1 1 0 0 0-1.415-1.414zM12 14.01l-.707.707a1 1 0 0 0 1.415 0zm-2.293-3.707a1 1 0 1 0-1.414 1.414zM21 11.08V12h2v-.92zm0 .92a9 9 0 0 1-1.792 5.383l1.602 1.198A11 11 0 0 0 23 12zm-1.792 5.383a9 9 0 0 1-4.656 3.242l.567 1.918a11 11 0 0 0 5.691-3.962zm-4.656 3.242a9 9 0 0 1-5.671-.189l-.693 1.877a11 11 0 0 0 6.93.23zm-5.671-.189a9 9 0 0 1-4.431-3.543L2.772 17.98a11 11 0 0 0 5.416 4.332zM4.45 16.894a9 9 0 0 1-1.43-5.49l-1.996-.133a11 11 0 0 0 1.748 6.711zm-1.43-5.49a9 9 0 0 1 2.138-5.256l-1.52-1.3a11 11 0 0 0-2.614 6.424zm2.138-5.256a9 9 0 0 1 4.859-2.931l-.441-1.951a11 11 0 0 0-5.938 3.582zm4.859-2.931a9 9 0 0 1 5.646.557l.814-1.826a11 11 0 0 0-6.901-.682zm11.276.077-10 10.01 1.415 1.414 10-10.01zm-8.586 10.01-3-3-1.414 1.414 3 3z'
    />
  </svg>
);
export default SvgCheckCircle;
